module.exports = __webpack_public_path__ + "img/funghi.b32e6ace.png";